import $ from "jquery";

$(function() {
    const $popup = $("#arosapopup");
    const $popupbg = $popup.find(".bg");

    function showPopup() {
        $popup.fadeIn(200);
    }
    function hidePopup() {
        $popup.fadeOut(200);
    }

    //window.setTimeout(showPopup, 1000);
    //$(".cta-arosa").on("click", showPopup);
    $("a[href='#arosapopup']").on("click", function(ev) {
        showPopup();
        ev.preventDefault();
    });

    $popupbg.on("click", function(ev) {
        if($(ev.target).closest(".content").length == 0) {
            hidePopup();
        }
    });

    $popup.find(".ctrcloseicon").on("click", hidePopup);
});
